angular.module('LeasePilot').factory('CompanyService', [
  'railsResourceFactory',
  function(railsResourceFactory) {
    return railsResourceFactory({
      url: '/api/companies',
      name: 'company',
    });
  },
]);
